const CALL_CRADLE_API = 'CALL_CRADLE_API';
const STORE_CRADLE_THROTTLE_VALUE = 'STORE_CRADLE_THROTTLE_VALUE';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const ASYNC_FETCH = 'ASYNC_FETCH';
export const CRADLE_API_INIT = 'CRADLE_API_INIT';
export const CRADLE_API_COMPLETED = 'CRADLE_API_COMPLETED';

export { CALL_CRADLE_API, STORE_CRADLE_THROTTLE_VALUE, ASYNC_FETCH_SUCCESS, ASYNC_FETCH };
